<template>
  <div id="reserve">
    <MyProgress :indexVal="0"/>
    <div>
      <!-- 图片信息上传 -->
      <MyLine text="请上传您的第二代身份证原件"/>
      <UploadPictures
          :fileUrl.sync="IDCardReverse"
          style="margin-top: 4vw;"
          num="1"
          title="先拍人像面"
          :errorMessage="IDCardReverseErr"
      />
      <UploadPictures
          :fileUrl.sync="IDCardFace"
          style="margin-top: 6vw;margin-bottom: 7.5vw"
          num="2"
          title="再拍国徽面"
          :errorMessage="IDCardFaceErr"
      />
      <MyLine text="请上传您的行驶证正本"/>
      <UploadPictures
          :fileUrl.sync="drivingLicense"
          style="margin-top: 6vw;margin-bottom: 7.5vw"
          num="1"
          title="行驶证正本"
          :errorMessage="drivingLicenseErr"
      />
      <div>
      <!-- 驾驶证信息 -->
<!--      <MyLine text="请按驾驶证信息填写"/>-->
<!--      <van-field-->
<!--          v-model="vehicleNum"-->
<!--          label="车牌号"-->
<!--          placeholder="请输入车牌号"-->
<!--          :error-message="vehicleNumErr"/>-->
<!--      <van-field-->
<!--          v-model="VIN"-->
<!--          label="车辆识别号"-->
<!--          placeholder="请输入车辆识别号"-->
<!--          :error-message="VINErr"/>-->
<!--      <van-field-->
<!--          v-model="EngineNum"-->
<!--          label="发动机号码"-->
<!--          placeholder="请输入发动机号码"-->
<!--          :error-message="EngineNumErr"/>-->
<!--      <van-cell-->
<!--          :class="`cell ${recordDate?'cell-on':''}`"-->
<!--          @click="showPopup(3)"-->
<!--          is-link-->
<!--          title="注册日期"-->
<!--          :value="recordDate?recordDate:'请选择注册日期' | dateFilter" />-->
<!--      <van-field-->
<!--          v-model="showOperate"-->
<!--          class="operate"-->
<!--          label="是否运营"-->
<!--          readonly-->
<!--          :placeholder="isOperate?'运营':'非运营'" >-->
<!--        <van-switch slot="button" v-model="isOperate" active-color="#53d769" size="8vw"/>-->
<!--      </van-field>-->
      </div>
      <!-- 用户信息 -->
      <MyLine text="联系方式"/>
      <van-field
          v-model="userName"
          label="姓名"
          placeholder="请输入姓名" />
      <van-field
          v-model="phoneNum"
          label="手机"
          placeholder="请输入手机号码"
          :error-message="phoneNumErr"/>
      <!-- 取车信息 -->
      <MyLine text="取车信息"/>
      <van-cell
          :class="`cell ${getVehicleDate?'cell-on':''}`"
          @click="showPopup(0)"
          is-link
          title="取车日期"
          :value="getVehicleDate?getVehicleDate:'请选择取车日期'" />
      <van-cell
          :class="`cell ${getVehicleTime?'cell-on':''}`"
          @click="showPopup(1)"
          is-link
          title="取车时间"
          :value="getVehicleTime?getVehicleTime:'请选择取车时间'" />
      <van-cell
          :class="`cell ${getVehicleAddr?'cell-on':''}`"
          @click="showPopup(2)"
          is-link
          title="取/还车地址"
          :value="getVehicleAddr?getVehicleAddr:'请选择镇街'" />
      <van-field
          v-model="detailedAddr"
          autosize
          type="textarea"
          rows="1"
          label=""
          placeholder="请输入详细地址" />
      <!-- 提示 -->
      <MyLine text="请准备以下材料正本"/>
      <div class="tips">
        <div>
          <img src="images/AAV/example1.png" alt="">
          <p>身份证</p>
        </div>
        <div>
          <img src="images/AAV/example2.png" alt="">
          <p>行驶证</p>
        </div>
        <div>
          <img src="images/AAV/example3.png" alt="">
          <p>驾驶证</p>
        </div>
        <div>
          <img src="images/AAV/example5.png" alt="">
          <p>交强险保单</p>
        </div>
      </div>
      <MyLine/>
      <!-- bottom -->
      <div>
        <div style="height: 13.067vw;"></div>
        <div class="bottom">
          <div class="left">
            <p>
            <span
                style="font-size: 3.733vw;color: #303133;"
            >实付&nbsp;</span>
              <span
                  style="font-size: 3.733vw;color: #2794eb;"
              >￥</span>
              <span
                  style="font-size: 5.333vw;color: #2794eb;"
              >{{'300'}}</span>
            </p>
            <p
                style="font-size: 3.2vw;color: #909399;"
            >办理完成后即可支付</p>
          </div>
          <van-button
              class="bottom-button"
              @click="submit"
              color="#2794eb"
              :disabled="isDisabled"
              :loading="isLoading"
          >预约年审</van-button>
        </div>
      </div>
      <!-- 弹出层 -->
      <div>
        <van-popup
            v-model="isShowPopup"
            position="bottom"
            round
        >
          <!-- 注册日期3 -->
          <div v-if="popupType===3">
            <van-datetime-picker
                type="date"
                :formatter="dateTimeFormatter"
                @confirm="setRegisterDate"
                @cancel="isShowPopup=false"
            />
          </div>
          <!-- 日期0 -->
          <div v-if="popupType===0">
            <van-datetime-picker
                type="date"
                :min-date="currentTime"
                :formatter="dateTimeFormatter"
                @confirm="setDate"
                @cancel="isShowPopup=false"
            />
          </div>
          <!-- 时间1 -->
          <div v-if="popupType===1">
            <van-datetime-picker
                v-model="getVehicleTime"
                type="time"
                :min-hour="10"
                :max-hour="20"
                @confirm="setTime"
                @cancel="isShowPopup=false"
            />
          </div>
          <!-- 地址2 -->
          <div v-if="popupType===2">
            <van-area
                :area-list="areaList"
                value="440606"
                @confirm="setAddr"
                @cancel="isShowPopup=false"
            />
          </div>
        </van-popup>
      </div>
    </div>
  </div>
</template>

<script>
  import MyProgress from '../widget/progress'
  import MyLine from  '../widget/line'
  import AreaList from '@/tool/area.js'
  import UploadPictures from '../widget/uploadPictures'
  import { applyFor } from '@/apis/aav.js'
  import {testCarNum, testVIN, testEngineNum} from "@/tool/regular";
  import {testTel} from "../../../tool/regular";

  export default {
    name: "index",
    components:{
      MyProgress,
      MyLine,
      AreaList,
      UploadPictures,
    },
    data() {
      return {
        IDCardReverse:null, // 身份证反面(url)
        IDCardFace:null, // 身份证正面(url)
        drivingLicense:null, // 行驶证(url)
        userName:'', // 姓名
        phoneNum:'', // 手机号码
        getVehicleDate:'', // 取车日期
        getVehicleTime:'', // 取车时间
        getVehicleAddr:'', // 取/还车地址
        detailedAddr:'', // 详细地址
        // 错误提示-----------------------------------------------------------------
        IDCardReverseErr:'',
        IDCardFaceErr:'',
        drivingLicenseErr:'',
        phoneNumErr:'',
        //-------------------------------------------------------------------------
        isDisabled: true, // 是否禁用按钮
        isLoading: false, // 是否申请中
        isShowPopup:false, // 是否展示弹出层
        currentTime:new Date(), // 当前时间
        popupType:0, // 弹出类型(0:日期, 1:时间, 2:地址, 3:注册日期)
      }
    },
    computed:{
      areaList() {return AreaList;}, // 地址列表
      all(){
        const {
          IDCardReverse, // 身份证反面(file)
          IDCardFace, // 身份证正面(file)
          drivingLicense, // 行驶证(file)
          userName, // 姓名
          phoneNum, // 手机号码
          getVehicleDate, // 取车日期
          getVehicleTime, // 取车时间
          getVehicleAddr, // 取/还车地址
          detailedAddr, // 详细地址
        } = this
        return {
          IDCardReverse, // 身份证反面(file)
          IDCardFace, // 身份证正面(file)
          drivingLicense, // 行驶证(file)
          userName, // 姓名
          phoneNum, // 手机号码
          getVehicleDate, // 取车日期
          getVehicleTime, // 取车时间
          getVehicleAddr, // 取/还车地址
          detailedAddr, // 详细地址
        }
      }
    },
    filters:{
      dateFilter(dateTime) {
        if ((''+dateTime).length === 10) {
          let date = new Date(dateTime*1000);
          return `${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()}`
        }
        return dateTime;
      },
      timeFilter(dateTime) {

      }
    },
    methods: {
      getNodeClass(yourIndex, index) {
        if (yourIndex < index) {
          return 'done'
        } else if (yourIndex === index) {
          return 'doing'
        } else if (yourIndex > index) {
          return 'unstarted'
        }
      },
      getTitleClass(yourIndex, index) {
        if (yourIndex < index) {
          return 't-done'
        } else if (yourIndex === index) {
          return 't-doing'
        } else if (yourIndex > index) {
          return ''
        }
      },
      // 显示Popup
      showPopup(type) {
        this.popupType = type;
        this.isShowPopup = true;
      },
      // 日期选项格式化
      dateTimeFormatter(type, value) {
        if (type === 'year') {
          return `${value}年`
        } else if (type === 'month') {
          return `${parseInt(value, 10)}月`
        } else if (type === 'day') {
          return `${parseInt(value, 10)}日`
        }
        return value;
      },
      setDate(date) {
          this.getVehicleDate = `${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()}`;
        this.isShowPopup = false;
      },
      setTime(time) {
        this.getVehicleTime = time;
        this.isShowPopup = false;
      },
      setAddr(addr) {
        this.getVehicleAddr = `${addr[0].name}${addr[1].name}${addr[2].name}`;
        this.isShowPopup = false;
      },
      setRegisterDate(date) {
        this.recordDate = date.getTime()/1000;
        // this.recordDate = `${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()}`;
        this.isShowPopup = false;
      },
      // 检查输入
      validateIpt() {
        if (
          this.userName &&
          this.phoneNum &&
          this.getVehicleDate &&
          this.getVehicleTime &&
          this.getVehicleAddr &&
          this.detailedAddr
        ) {this.secondValidate()}
        else {this.isDisabled = true;}
      },
      // 二次检查
      secondValidate() {
        // 身份证反面验证
        if (this.IDCardReverse) {
          this.IDCardReverseErr = '';
        } else  {this.IDCardReverseErr = '请上传身份证反面照片';this.isDisabled=true;return;}
        // 身份证正面验证
        if (this.IDCardFace) {
          this.IDCardFaceErr = '';
        } else  {this.IDCardFaceErr = '请上传身份证正面照片';this.isDisabled=true;return;}
        // 行驶证验证
        if (this.drivingLicense) {
          this.drivingLicenseErr = '';
        } else  {this.drivingLicenseErr = '请上传行驶证正本照片';this.isDisabled=true;return;}
        // 手机号验证
        if (testTel(this.phoneNum)) {
          this.phoneNumErr = '';
        } else {this.phoneNumErr='请填入正确的手机号';this.isDisabled=true;return;}
        this.isDisabled = false;
      },
      // 预约年审
      submit() {
        this.isLoading = true;
        let operateType = this.isOperate ? 1 : 0;
        let dateTime = new Date(this.getVehicleDate + ' ' + this.getVehicleTime).getTime()/1000;
        let addr = this.getVehicleAddr + this.detailedAddr;
        applyFor(
          this.IDCardFace,
          this.IDCardReverse,
          this.drivingLicense,
          this.userName,    // 姓名
          this.phoneNum,    // 电话
          dateTime,         // 取车日期
          addr              // 取/还车地址
        ).then(res => {
          this.isLoading = false;
          this.$router.push('/AAV/reserve/success?id='+res.data);
        }).catch(e => {
          this.isLoading = false;
          this.$toast('提交失败');
        });
      }
    },
    watch:{
      all(_) {
        this.validateIpt();
      }
    }
  }
</script>

<style scoped>
  #reserve{
    background: white;
  }
  .tips{
    display: flex;
    height: 29.333vw;
    align-items: center;
  }
  .tips>div{
    flex: 1;
    text-align: center;
  }
  .tips img{
    width: 15.467vw;
    height: 15.467vw;
    object-fit: contain;
  }
  .tips p{
    font-size: 3.467vw;
    color: #303133;
    margin-top: 2.5vw;
  }
  .bottom{
    width: 100%;
    height: 13.067vw;
    background: white;
    position: fixed;
    bottom: 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .bottom>.left{
    margin-left: 4.267vw;
  }
  .bottom-button{
    width: 36vw;
    height: 13.067vw;
    font-size: 4.8vw;
  }

  .focusState{position: absolute;}

  .operate>>>.van-field__label{display: flex;align-items: center;}
  .operate>>>.van-field__button{display: flex}
  .operate>>>.van-field__control{color: #323233}
  .cell>>>.van-cell__title{width: 90px;flex: none;}
  .cell>>>.van-cell__value{text-align: left; }
  /* 已选后的的cell */
  .cell-on>>>.van-cell__value{color: #323233}
</style>
